import cbpPortCodes from '@/lib/data/cbpPortCodes.json'

const PORT_CODE_PATTERN = /^\d{4}$/
const PORT_CODE_TRAILING_PATTERN = /^(.*?)[\s(-]+(\d{4})\)?$/

export function lookupPortNameByCode(code: string | null | undefined) {
  if (!code) return null
  const normalized = code.trim()
  if (!PORT_CODE_PATTERN.test(normalized)) return null
  return cbpPortCodes[normalized as keyof typeof cbpPortCodes] ?? null
}

export function formatPortDisplay(value: string | null | undefined) {
  if (!value) return null
  const normalized = value.trim()
  if (!normalized) return null

  if (PORT_CODE_PATTERN.test(normalized)) {
    const portName = lookupPortNameByCode(normalized)
    return portName ? `${portName} - ${normalized}` : normalized
  }

  const trailingCodeMatch = normalized.match(PORT_CODE_TRAILING_PATTERN)
  if (!trailingCodeMatch) return normalized

  const [, fallbackName, code] = trailingCodeMatch
  const portName = lookupPortNameByCode(code) ?? fallbackName.trim()
  return `${portName} - ${code}`
}
